import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import BaseForm from './BaseForm';
import nothing from './nothing';

var Quick = function Quick(parent) {
  var _ =
  /*#__PURE__*/
  function (_parent) {
    _inherits(_, _parent);

    function _() {
      _classCallCheck(this, _);

      return _possibleConstructorReturn(this, _getPrototypeOf(_).apply(this, arguments));
    }

    _createClass(_, [{
      key: "getNativeFormProps",
      value: function getNativeFormProps() {
        var _a = _get(_getPrototypeOf(_.prototype), "getNativeFormProps", this).call(this),
            _a$autoField = _a.autoField,
            AutoField = _a$autoField === void 0 ? this.getAutoField() : _a$autoField,
            _a$errorsField = _a.errorsField,
            ErrorsField = _a$errorsField === void 0 ? this.getErrorsField() : _a$errorsField,
            _a$submitField = _a.submitField,
            SubmitField = _a$submitField === void 0 ? this.getSubmitField() : _a$submitField,
            props = __rest(_a, ["autoField", "errorsField", "submitField"]);

        if (!props.children) {
          props.children = this.getChildContextSchema().getSubfields().map(function (key) {
            return React.createElement(AutoField, {
              key: key,
              name: key
            });
          }).concat([React.createElement(ErrorsField, {
            key: "$ErrorsField"
          }), React.createElement(SubmitField, {
            key: "$SubmitField"
          })]);
        }

        return props;
      }
    }, {
      key: "getAutoField",
      value: function getAutoField() {
        return function () {
          return nothing;
        };
      }
    }, {
      key: "getErrorsField",
      value: function getErrorsField() {
        return function () {
          return nothing;
        };
      }
    }, {
      key: "getSubmitField",
      value: function getSubmitField() {
        return function () {
          return nothing;
        };
      }
    }]);

    return _;
  }(parent);

  _.Quick = Quick;
  _.displayName = "Quick".concat(parent.displayName);
  _.propTypes = Object.assign(Object.assign({}, parent.propTypes), {
    autoField: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    errorsField: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    submitField: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
  });
  return _;
};

export default Quick(BaseForm);